import React, { useEffect, useState } from 'react';

export const ImmersionRC = () => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="immersionRC__section">
      <div className="immersionRC__content--wrapper responsive__padding">
        <div className="immersionRC__text--wrapper">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <h3 className="immersionRC__subtitle">VIDEO TRANSMISSION</h3>
            <h2 className="immersionRC__title">BETTER THAN EVER</h2>
          </div>
          <p className="dreamX__body">
            Equipped with Hybrid Duo for exceptional video quality and extended
            range.
          </p>
        </div>
      </div>
      <div className="image-wrapper">
        <img
          src={
            windowWidth > 767
              ? require('main/assets/images/dreamX/Camera 1.webp')
              : require('main/assets/images/dreamX/Camera-mobile.webp')
          }
          alt="Long Range Video Transmission Technology"
          className="immersionRC__image"
        />
      </div>
    </section>
  );
};
